import styled from 'styled-components';

const ConfirmModal = styled.div`
  position: fixed;
  top: 20vh;
  left: calc(50vw - 150px);
  padding: 30px;
  width: 300px;
  background-color: white;
  border-radius: 8px;
  z-index: 1002;
  display: flex;
  flex-direction: column;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 40px;
`;
const ConfirmButton = styled.div`
  width: 40%;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(p) => p.theme.color.teal};
  color: white;
  font-weight: 600;
`;
const DeclineButton = styled.div`
  width: 40%;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(p) => p.theme.color.red};
  color: white;
  font-weight: 600;
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1001;
`;

export { ConfirmModal, ButtonWrapper, ConfirmButton, DeclineButton, Overlay };



// WEBPACK FOOTER //
// ./src/views/Member/styles.js